<template>
    <b-modal title="Witness Examination"
             size="lg"
             class="font-weight-bold"
             centered
             no-close-on-backdrop
             v-model="dialogOpen"
             @hidden="onDialogHidden">
        <!--this binds the enter key to the insert event, i.e. makes the OK button the default button-->
        <vue-keypress key-event="keydown" :key-code="13" @success="handleEnterKey"></vue-keypress>
        <b-alert v-model="showErrors" variant="danger" dismissible>
            <div v-for="(error, index) in currentErrors" :key="index">
                <p>{{ error }}</p>
            </div>
        </b-alert>
        <div ref="inputFields">
            <b-form-row v-if="currentConfiguration && currentConfiguration.ExaminationTypeOptions">
                <b-form-group label="Examination Type"
                              label-for="examinationTypeFlags"
                              class="col-md-6">
                    <b-form-radio-group name="examinationType"
                                        v-model="examinationType"
                                        stacked>
                        <template v-for="(examinationTypeOption, index) in examinationTypeOptions">
                            <vue-keypress key-event="keydown"
                                          :key-code="examinationTypeOption.shortcut.keyCode"
                                          :modifiers="examinationTypeOption.shortcut.modifiers"
                                          :preventDefault="true"
                                          @success="examinationType = examinationTypeOption.value"
                                          :key="'keypress' + index"
                                          v-if="examinationTypeOption.shortcut"></vue-keypress>
                            <b-form-radio :value="examinationTypeOption.value" :key="'examinationtypeoption' + index">
                                {{ examinationTypeOption.text }}
                                <template v-if="examinationTypeOption.shortcut">
                                    ({{ examinationTypeOption.shortcut.text }})
                                </template>
                            </b-form-radio>
                        </template>
                    </b-form-radio-group>
                </b-form-group>
                <b-form-group label="Extra Options"
                              label-for="examinationTypeFlags"
                              class="col-md-6"
                              v-if="currentConfiguration && currentConfiguration.ExaminationTypeFlagOptions">
                    <b-form-checkbox-group name="examinationTypeFlags"
                                           v-model="examinationTypeFlags"
                                           switches
                                           stacked>
                        <template v-for="(examinationTypeFlagOption, index) in examinationTypeFlagOptions">
                            <vue-keypress key-event="keydown"
                                          :key-code="examinationTypeFlagOption.shortcut.keyCode"
                                          :modifiers="examinationTypeFlagOption.shortcut.modifiers"
                                          :preventDefault="true"
                                          @success="toggleExaminationTypeFlag(examinationTypeFlagOption.value)"
                                          :key="'keypress' + index"
                                          v-if="examinationTypeFlagOption.shortcut"></vue-keypress>
                            <b-form-checkbox :value="examinationTypeFlagOption.value" :key="'checkbox' + index">
                                {{ examinationTypeFlagOption.text }}
                                <template v-if="examinationTypeFlagOption.shortcut">
                                    ({{ examinationTypeFlagOption.shortcut.text }})
                                </template>
                            </b-form-checkbox>
                        </template>
                    </b-form-checkbox-group>
                </b-form-group>
            </b-form-row>

            <hr />

            <b-form-row v-if="(currentConfiguration != null) && (currentConfiguration.CounselSpeakers != null)">
                <b-container>
                    <b-row class="text-left" v-for="(speaker, index) in currentConfiguration.CounselSpeakers" :key="index">

                        <b-col cols="2">{{ speaker.Title }}</b-col>
                        <b-col cols="4">{{ speaker.Surname }}</b-col>
                        <b-col cols="3">{{ speaker.OtherNames }}</b-col>

                        <vue-keypress key-event="keydown"
                                      :key-code="index + 49"
                                      :modifiers='["altKey"]'
                                      :preventDefault="true"
                                      @success="useThisSpeaker(speaker)"
                                      :key="'keypress' + index + 49"
                                      v-if="index < 9"></vue-keypress>

                        <b-col cols="3">
                            <b-button variant="info" class="text-nowrap rounded-right m-1" v-on:click="useThisSpeaker(speaker)">
                                Use Speaker<template v-if="index < 9"> [Alt+{{ index + 1 }}]</template>
                            </b-button>

                        </b-col>

                    </b-row>
                </b-container>
            </b-form-row>

            <b-form-row class="mt-3">
                <b-form-group label="Counsel Title"
                              label-for="counselTitle"
                              class="col-md-2">
                    <b-form-input name="counselTitle"
                                  v-model="counselTitle"
                                  autofocus>
                    </b-form-input>
                </b-form-group>
                <b-form-group label="Counsel Surname"
                              label-for="counselSurname"
                              class="col-md-4">
                    <b-form-input name="counselSurname"
                                  v-model="counselSurname">
                    </b-form-input>
                </b-form-group>
                <b-form-group label="Counsel Other Names"
                              label-for="counselOtherNames"
                              class="col-md-3">
                    <b-form-input name="counselOtherNames"
                                  v-model="counselOtherNames">
                    </b-form-input>
                </b-form-group>
                <b-form-group label="Time"
                              label-for="time"
                              class="col-md-3">
                    <b-form-input name="time"
                                  v-model="time"
                                  type="time">
                    </b-form-input>
                </b-form-group>
            </b-form-row>


        </div>
        <template v-slot:modal-footer="{ cancel }">
            <b-button variant="danger" @click="reset">Reset</b-button>
            <b-button @click="cancel">Cancel</b-button>
            <b-button variant="success" @click="insert">OK</b-button>
        </template>
    </b-modal>
</template>

<script>
    import $ from 'jquery';
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import VueKeypress from 'vue-keypress';
    import { v4 as newUuid } from 'uuid';

    import DateTimeMixin from '../../mixins/DateTimeMixin';
    import InputMixin from '../../mixins/InputMixin';
    import EventsMixin from '../../mixins/EventsMixin';

    Vue.use(BootstrapVue);

    export default {
        name: 'TopscribeWitnessExaminationDialog',
        mixins: [DateTimeMixin, InputMixin, EventsMixin],
        components: {
            'vue-keypress': VueKeypress
        },
        model: {
            event: 'change',
            prop: 'active',
            
        },
        props: {
            configuration: {
                type: Object,
                default: null
            },
            active: {
                type: Boolean,
                default: false
            },
            mode: {
                type: String,
                default: 'insert',
                validator: function (value) {
                    // The value must match one of these strings
                    return (['insert', 'edit'].indexOf(value) !== -1);
                }
            },
            currentEditorSection: {
                default: null
            }
        },
        data: function () {
            return {
                dialogOpen: this.active,
                currentConfiguration: this.configuration,
                currentErrors: null,
                showErrors: false,
                examinationType: null,
                examinationTypeFlags: [],
                counselTitle: null,
                counselSurname: null,
                counselOtherNames: null,
                time: null,

                sectionsInsertedEventData: null
            }
        },
        computed: {
            examinationTypeOptions: function () {
                return this.currentConfiguration.ExaminationTypeOptions;
            },
            examinationTypeFlagOptions: function () {
                return this.currentConfiguration.ExaminationTypeFlagOptions;
            }
        },
        watch: {
            configuration: function () {
                this.currentConfiguration = this.configuration;
                console.log(JSON.stringify(this.currentConfiguration));
            },
            active: function () {
                if (this.active) {
                    //the dialog is about to open
                    this.currentErrors = null;
                    if (this.mode == 'edit') {
                        try {
                            var base64EncodedMetaData = $(this.currentEditorSection).data('metadata');
                            var metaData = JSON.parse(atob(base64EncodedMetaData));
                            this.examinationType = metaData.ExaminationType;
                            this.examinationTypeFlags = metaData.ExaminationTypeFlags;
                            if (this.examinationTypeFlags == null) this.examinationTypeFlags = [];
                            this.counselTitle = metaData.CounselTitle;
                            this.counselSurname = metaData.CounselSurname;
                            this.counselOtherNames = metaData.CounselOtherNames;
                            this.time = (metaData.Time == null) ? null : this.formatDateTime(metaData.Time, 'HH:mm', true, true);
                        }
                        catch
                        {
                            console.warn('invalid metadata in section');
                        }
                    } else {
                        this.examinationType = null;
                        this.examinationTypeFlags = [];
                        this.counselTitle = null;
                        this.counselSurname = null;
                        this.counselOtherNames = null;
                    }
                    this.sectionsInsertedEventData = null;
                }
                this.dialogOpen = this.active;
            },
            currentErrors: function () {
                this.showErrors = (this.currentErrors != null) && (this.currentErrors.length > 0);
            }
        },
        methods: {

            useThisSpeaker: function (speaker) {
                this.counselTitle = speaker.Title;
                this.counselSurname = speaker.Surname;
                this.counselOtherNames = speaker.OtherNames;
            },

            speakerFullname: function (speaker) {
                var fullName = '';
                if (speaker.Title != null) {
                    fullName += speaker.Title;
                }
                if (speaker.Surname != null) {
                    if (fullName.length > 0) {
                        fullName += " ";
                    }
                    fullName += speaker.Surname;
                }
                if (speaker.OtherNames != null) {
                    if (fullName.length > 0) {
                        fullName += " ";
                    }
                    fullName += speaker.OtherNames;
                }
                return fullName;
            },

            toggleExaminationTypeFlag: function (examinationTypeFlag) {
                var examinationTypeFlagIndex = this.examinationTypeFlags.indexOf(examinationTypeFlag);
                if (examinationTypeFlagIndex < 0) {
                    this.examinationTypeFlags.push(examinationTypeFlag);
                } else {
                    this.examinationTypeFlags.splice(examinationTypeFlagIndex, 1);
                }
            },
            handleEnterKey: function (e) {
                if (this.isEventTargetWithinElement(e.event, this.$refs.inputFields)) {
                    this.insert();
                }
            },
            reset: function () {
                this.examinationType = null;
                this.examinationTypeFlags = [];
                this.currentErrors = null;
                this.counselTitle = null;
                this.counselSurname = null;
                this.counselOtherNames = null;
                this.time = null;
            },
            insert: function () {
                this.currentErrors = []
                if (this.examinationType == null) {
                    this.currentErrors.push('An examination type selection is required');
                }
                //if ((this.counselTitle == null) || (this.counselTitle.trim().length == 0)) {
                //    this.currentErrors.push('A counsel title is required');
                //}
                if ((this.counselSurname == null) || (this.counselSurname.trim().length == 0)) {
                    this.currentErrors.push('A counsel surname is required');
                }
                //if ((this.counselOtherNames == null) || (this.counselOtherNames.trim().length == 0)) {
                //    this.currentErrors.push('A counsel other name is required');
                //}
                if (this.currentErrors.length == 0) {
                    var examinationTypeOption = this.findOptionEntry(this.currentConfiguration.ExaminationTypeOptions, this.examinationType);
                    var time = ((this.time == null) || (this.time.trim().length == 0)) ? null : this.parseDateTime(this.time, 'HH:mm', true, true);
                    var metaData = {
                        SectionId: newUuid(),
                        Type: 'witness',
                        SubType: 'examination',
                        ExaminationType: this.examinationType,
                        ExaminationTypeFlags: this.examinationTypeFlags,
                        CounselTitle: this.counselTitle,
                        CounselSurname: this.counselSurname,
                        CounselOtherNames: this.counselOtherNames,
                        Time: time
                    }

                    var content = examinationTypeOption.text.toUpperCase();
                    if ((this.counselTitle != null) || (this.counselOtherNames != null) || (this.counselSurname != null)) {
                        content += ' BY ';
                        if (this.counselTitle != null) {
                            content += this.counselTitle.trim().toUpperCase();
                            content += ' ';
                        }
                        if (this.counselOtherNames != null) {
                            content += this.counselOtherNames.trim().toUpperCase();
                            content += ' ';
                        }
                        if (this.counselSurname != null) {
                            content += this.counselSurname.trim().toUpperCase();
                        }
                    }
                    if (time != null) {
                        content += ' AT ' + this.formatDateTime(time, 'h:mmA', true, true);
                    }
                    if (this.examinationTypeFlags && this.examinationTypeFlags.length) {
                        content += '<br/>('
                        var first = true;
                        this.examinationTypeFlags.forEach((examinationTypeFlag) => {
                            if (!first) content += ', ';
                            content += this.findOptionEntry(this.currentConfiguration.ExaminationTypeFlagOptions, examinationTypeFlag).text.toUpperCase();
                            first = false;
                        });
                        content += ')';
                    }
                    var base64EncodedMetaData = btoa(JSON.stringify(metaData));
                    this.$emit('beforeSectionsInsertOrUpdate');
                    Vue.nextTick(() => {
                        var witnessExaminationSection =
                            $('<div data-type="witness" data-sub-type="examination"/>')
                                .attr('id', metaData.SectionId)
                                .attr('data-metadata', base64EncodedMetaData)
                                .html(content)
                                .attr('data-content', content)
                                .data('content', content)
                                .insertAfter(this.currentEditorSection)[0];
                        if (this.mode == 'edit') {
                            $(this.currentEditorSection).remove(); //remove the old section
                        }
                        this.sectionsInsertedEventData = { sections: [witnessExaminationSection] };
                        this.dialogOpen = false;
                    });
                }
            },
            onDialogHidden: function () {
                this.reset();
                this.$emit('change', false);
                if (this.sectionsInsertedEventData) {
                    this.$emit('sectionsInserted', this.sectionsInsertedEventData);
                } else {
                    this.$emit('cancelled');
                }
                this.sectionsInsertedEventData = null;
            }
        } 
    }
</script>
